import { render, staticRenderFns } from "./MdPatientInfoBox.vue?vue&type=template&id=3fd6c2ab&"
import script from "./MdPatientInfoBox.vue?vue&type=script&lang=js&"
export * from "./MdPatientInfoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports